import { DrivingLicence_Enum } from "src/types/enums";
import type { PayoutPackage } from "src/types/loan-application";

export default function trimDocumentReqs(pack: PayoutPackage, drivingLicenceType: DrivingLicence_Enum){
    if(pack && drivingLicenceType){
        let dls = pack.customerRequirements.filter(r => r.requirementName.includes("Driving"));
        
        pack.customerRequirements = pack.customerRequirements.filter(r => !r.requirementName.includes("Driving"));

        let existing = dls.find(r => r.hasFiles);
        if(existing){
            pack.customerRequirements = [existing];
        }
        else {
            switch(drivingLicenceType){
                case DrivingLicence_Enum['Full UK']:
                    pack.customerRequirements = [...dls.filter(r => r.requirementName.includes("UK") && r.requirementName.includes("Full")), ...pack.customerRequirements];
                    break;
                case DrivingLicence_Enum.EU:
                    pack.customerRequirements = [...dls.filter(r => r.requirementName.includes("EU")), ...pack.customerRequirements];
                    break;
                case DrivingLicence_Enum['Provisional UK']:
                    pack.customerRequirements = [...dls.filter(r => r.requirementName.includes("Provisional") && r.requirementName.includes("UK")), ...pack.customerRequirements];
                    break;
                case DrivingLicence_Enum['International']:
                pack.customerRequirements = [...dls.filter(r => r.requirementName.includes("International")), ...pack.customerRequirements];
                    break;  
            }
        }
        
    }
    if(pack && pack.financeRequirements && pack.financeRequirements.length > 1){
        //if specified
        if(pack.financeRequirements.filter(r => r.requirementId > 0).length === 1){
            pack.financeRequirements = pack.financeRequirements.filter(r => r.requirementId > 0);
        }
        //if not prefer esign
        else if(pack.financeRequirements.filter(r => !r.hasFiles).length > 1){
            pack.financeRequirements = pack.financeRequirements.filter(r => r.requirementTypeId === 90); // customer esign
        }
    }
    return pack;
}